module.exports = __webpack_public_path__ + "static/media/GenShinGothic.abfe968e.ttf";